<template>
  <inline-svg v-if="svgSrc" :src="svgSrc" class="h-[20px] w-[20px] inline" />
  <span v-else :class="classes"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { NbIcons } from './NbIcons'
import InlineSvg from '@/components/InlineSvg'
import ListSvg from '@/assets/img/list.svg'
import RefreshSvg from '@/assets/img/refresh.svg'
import PulsarSvg from '@/assets/img/pulsar.svg'
import KafkaSvg from '@/stories/assets/logos/kafka.svg'
import DeltaLakeSvg from '@/stories/assets/logos/deltalake-wire.svg'
import IcebergSvg from '@/stories/assets/logos/iceberg.svg'
import SnowflakeSvg from '@/stories/assets/logos/snowflake.svg'
import UnitySvg from '@/stories/assets/logos/unity.svg'
import StreamNativeSvg from '@/stories/assets/logos/streamnative.svg'
import s3Svg from '@/stories/assets/logos/s3.svg'
import MqttSvg from '@/stories/assets/logos/mqtt-gray.svg'
import UnilinkEmptySvg from '@/assets/img/unilink-empty.svg'
import ConsumerSvg from '@/assets/img/consumer.svg'
import ConsumerGroupSvg from '@/assets/img/consumer-group.svg'
import KafkaSchemaSvg from '@/assets/img/kafka-schema.svg'
import GoogleLogo from '@/assets/img/google-login.svg'
import AzureLogo from '@/stories/assets/logos/azure.svg'
import AWSLogo from '@/stories/assets/logos/aws.svg'
import GCPLogo from '@/stories/assets/logos/googlecloud.svg'
import RBACLogo from '@/assets/img/rbac.svg'
import RobotSvg from '@/assets/img/robot.svg'
import UndoSvg from '@/assets/img/undo.svg'
import SimpleAlicloudSvg from '@/stories/assets/logos/alibabacloud.svg'
import McpServerSvg from '@/assets/img/mcp-server.svg'

const props = withDefaults(defineProps<NbIcons>(), {
  isSmall: false,
  color: '',
  symbol: 'close',
  type: 'font'
})
const classes = computed(() => ({
  'nb-i': true,
  'nb-i-sm': props.isSmall,
  [`nb-i-${props.symbol}`]: true,
  [`nb-ct-${props.color}`]: props.color
}))

const svgSrc = computed(() => {
  switch (props.symbol) {
    case 'list':
      return ListSvg
    case 'refresh':
      return RefreshSvg
    case 'pulsar':
      return PulsarSvg
    case 'kafka':
      return KafkaSvg
    case 'mqtt':
      return MqttSvg
    case 'unilink-empty':
      return UnilinkEmptySvg
    case 'consumer':
      return ConsumerSvg
    case 'consumer-group':
      return ConsumerGroupSvg
    case 'kafka-schema':
      return KafkaSchemaSvg
    case 'google':
      return GoogleLogo
    case 'gcp':
      return GCPLogo
    case 'aws':
      return AWSLogo
    case 'azure-cloud':
      return AzureLogo
    case 'rbac':
      return RBACLogo
    case 'robot':
      return RobotSvg
    case 'undo':
      return UndoSvg
    case 'iceberg':
      return IcebergSvg
    case 'deltalake':
      return DeltaLakeSvg
    case 'snowflake':
      return SnowflakeSvg
    case 'unity':
      return UnitySvg
    case 's3':
      return s3Svg
    case 'streamnative':
      return StreamNativeSvg
    case 'alibaba-cloud':
      return SimpleAlicloudSvg
    case 'mcp-server':
      return McpServerSvg
  }
  return ''
})
</script>
